import React, { useEffect, useState } from 'react';
import { Box, Button, TextField, Typography, Alert, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { PlanViewerWithPopup } from '@Pages/RegulatoryMember/ExitRequestDetail/PlanViewerWithPopup';

/**
 * Read-only for everybody; an editable form with a confirm dialog for the Regulatory owner
 * while the request is PENDING_LOCAL_RISK_ASSESSMENT.
 */
export const LocalRiskAssessmentSection = ({ plan, canSubmit, submitting, onSubmit }) => {
  const [text, setText] = useState(plan?.localRiskAssessment || '');
  const [confirmOpen, setConfirmOpen] = useState(false);

  useEffect(() => {
    setText(plan?.localRiskAssessment || '');
  }, [plan?.localRiskAssessment]);

  const formatDate = (date) => (date ? new Date(date).toLocaleDateString() : '');

  if (!canSubmit) {
    return (
      <Box>
        <PlanViewerWithPopup
          title="Local Regulatory Risk Assessment"
          content={plan?.localRiskAssessment || 'Not provided yet'}
        />
        {plan?.localRiskAssessmentBy && (
          <Typography variant="caption" color="textSecondary">
            Assessed by {plan.localRiskAssessmentBy.username} on {formatDate(plan.localRiskAssessmentDate)}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <Alert severity="info">
        This exemption request is waiting for your Local Regulatory Risk Assessment. Submitting it forwards the request to the approving managers.
      </Alert>
      <TextField
        label="Local Regulatory Risk Assessment *"
        multiline
        minRows={6}
        fullWidth
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant="contained" disabled={submitting || !text.trim()} onClick={() => setConfirmOpen(true)}>
          {submitting ? 'Submitting...' : 'Submit Risk Assessment & Forward for Approval'}
        </Button>
      </Box>

      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Forward for approval?</DialogTitle>
        <DialogContent>
          <Typography>The approving managers will be notified and asked to approve or reject this exemption request.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)} disabled={submitting}>Cancel</Button>
          <Button
            variant="contained"
            disabled={submitting}
            onClick={async () => {
              const ok = await onSubmit(text.trim());
              if (ok) setConfirmOpen(false);
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default LocalRiskAssessmentSection;
